import axios from "axios";
import React, {useEffect, useState} from 'react'
import Footer from "./parts/footer";
import CustomGallery from "./gallery/gallery";
import Formats from "./formats/formats";
import AdvantagesOne from "./advantages/advantages";
import Awarding from "./awarding/awarding";
import EbAutOne from "./ebaut-event/ebaut";
import Header from "./parts/header";
import EventThemesBase from "./themes/themes-base";
import EventSpeacersBase from "./speacers/speacers-base"
import EventPartnersBase from "./partners/partners-base"
import PartnersTopNew from "./partners/partners-top-new"
import EventPanelBase from "./panel/panel-base";
import EventProgram from "./program/program-base"
import FirstScreen from "./first-screen/firstscreen";
import EventOrganizers from "./organizers/organizers"
import EventVideo from "./video/video"
import OldSpeacers from "./speacers/speacers-old";
import Statistic from "./statistic/statistic";
import EventPanelNew from "./panel/panel-new";

function Home() {

    const [post, setPosts] = useState([]);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/3353?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [post.data])

    let advantagesData = post.advantages
    let ebautData = post.ebaut_event
    let fsData = post.fs_group
    let formatsData = post.formats
    let myGallery = post.gallery
    let awardingData = post.awarding
    let speacersData = post.speacers
    let partnersBaseData = post.partners_bottom
    let partnersTopData = post.partners_top_new
    let panelData = post.panel
    let themesData = post.theme
    let programData = post.program

    return (
        <>
            <Header/>
            <FirstScreen fsData={fsData} />
            <Statistic />
            <PartnersTopNew partnersTopData={partnersTopData} />
            <EbAutOne ebautData={ebautData} />
            {/*<AdvantagesOne advantagesData={advantagesData} />*/}
            <EventSpeacersBase speacersData={speacersData} />
            <Formats formatsData={formatsData} />
            {/*<EventPanelNew />*/}
            <EventProgram programData={programData} />
            {/*<OldSpeacers />*/}
            {/*<EventThemesBase themesData={themesData} />*/}
            {/*<EventPanelBase panelData ={panelData}  />*/}
            {/*<Awarding awardingData={awardingData} />*/}
            {/*<CustomGallery myGallery={myGallery} />*/}
            {<EventOrganizers/>}
            <EventPartnersBase partnersBaseData={partnersBaseData}/>
            <Footer />
        </>
    )
}

export default Home;